import { render } from "./BreadCrumb.vue?vue&type=template&id=76bd6fca&scoped=true"
import script from "./BreadCrumb.vue?vue&type=script&lang=js"
export * from "./BreadCrumb.vue?vue&type=script&lang=js"

import "./BreadCrumb.vue?vue&type=style&index=0&id=76bd6fca&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-76bd6fca"

export default script